import ThemedLayout from 'components/atoms/ThemedLayout'
import i18n from 'utils/i18n'
import ThemedSafeAreaComponentTop from 'components/atoms/ThemedSafeAreaTop'
import React, { useEffect, useState } from 'react'
import { useShowHamburger } from 'utils/helper-device'
import { constantsActive } from 'utils/constants/constants'
import ManagementGroupedThemeList from 'components/management/molecules/ManagementGroupedThemeList'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import ManagementHeader from 'components/management/molecules/ManagementHeader'
import ListItem from 'components/atoms/ListItem'
import { listArrow } from 'styles/list'
import { useIsFocused, useNavigation } from '@react-navigation/native'
import FetchManagementEmails from 'utils/fetch/management/FetchManagementEmails'
import { AppRoutes } from 'navigations/app-routes'

const ManagementEmailsIndexScene = () => {
	
	const navigation = useNavigation();
	const isFocused = useIsFocused();
	const showHamburger = useShowHamburger();
	
	const [ loading, setLoading ] = useState( true )
	const [ search, setSearch ] = useState('')
	const [ emailTemplates, setEmailTemplates ] = useState( [] )
	
	const fetchEmails = () => {
		FetchManagementEmails.fetchAll({
			callbackStart: setLoading.bind( this, true ),
			callbackError: setLoading.bind( this, false ),
			callbackSuccess: items => {
				setLoading.bind( this, false )
				
				setEmailTemplates( items )
			},
		})
	}
	
	const onPressCreateEmail = () => {
		onPressEmail( {} );
	}
	
	const onPressEmail = ( item ) => {
		navigation.navigate( AppRoutes.MANAGEMENT_SETTINGS_EMAILS_EDIT, {
			guid: item.guid
		} );
	}
	
	const renderItem = ( { item, index } ) => {
		return (
			<ListItem
				title={ i18n.t( `management:form.type.${item.type}`) }
				subtitle={ item.time }
				title_add_active_tag={ true }
				item={ item }
				accessoryRight={ listArrow }
				onPress={ onPressEmail }
			/>
		)
	}
	
	useEffect( () => {
		return fetchEmails();
	}, [ isFocused ] )
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				title={i18n.t('management:pages.emails.index.title')}
				topNavigation={true}
				topNavigationProps={{
					showHamburgerDrawer: showHamburger
				}}>
				
				<ManagementGroupedThemeList
					header={(
						<ManagementHeader
							inputs={[
								{
									placeholder: i18n.t( 'management:pages.emails.index.input_search'),
									//onChangeText: _.debounce( setSearch, 400 )
								}
							]}
							addButton={ HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.SETTINGS ) ? { onPress: onPressCreateEmail } : null }
						/>
					)}
					items={ emailTemplates }
					renderItem={ renderItem.bind( this ) }
					groupByKey={ 'active' }
					//filters={ filters }
					groupByValues={ [
						constantsActive.YES,
						constantsActive.NO
					] }
				/>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	)
}

export default ManagementEmailsIndexScene
